export class Params {
    public userName: string;
    public currentPassword: string;
    public newPassword: string;
    public confirmPassword: string;
    public email: string;
}



// WEBPACK FOOTER //
// ./src/models/params.ts